"use strict";

angular.module("core")
.component("orderContactTypeFilter", {
    bindings: {
        filter: "<?",
        service: "<"
    },
    templateUrl: require("./order-contact-type-filter.component.html"),
    controllerAs: "orderContactTypeFilterCtrl",
    controller: function($scope, $stateParams, ConvertToParameterService) {
        var _this = this;

        this.selectedContactType = {};

        function query() {
            _this.service.query(_this.filter).$promise.then(function(contactTypeFilters) {
                _this.contactTypeFilters = contactTypeFilters;
                if ($stateParams.contact_type) {
                    var contactTypeParams = $stateParams.contact_type.split(",");

                    angular.forEach(contactTypeFilters, function(value) {
                        if (contactTypeParams.indexOf(value.key) >= 0) {
                            _this.selectedContactType[value.key] = value.key;
                        }
                    });
                }
            });
        }

        this.updateContactTypeFilter = function() {
            var selectedContactType = ConvertToParameterService.convertValuesToParameter(this.selectedContactType);
            $scope.$emit("orderContactTypeFilterUpdated", {contact_type: selectedContactType});
        };

        query();

        $scope.$on("resetListing", function() {
            query();
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/order-contact-type-filter/order-contact-type-filter.component.js
// module id = 601
// module chunks = 0